import { safeName } from "helpers/common";

export function prompt(config, app) {
	const result = new webix.promise.defer();

	webix
		.ui(
			app.getService("jet-win").updateConfig({
				view: "window",
				css: "webix_fmanager_prompt",
				head: {
					view: "toolbar",
					padding: { left: 12, right: 4 },
					borderless: true,
					elements: [
						{ view: "label", label: config.text },
						{
							view: "icon",
							icon: "wxi-close",
							hotkey: "esc",
							click: function() {
								result.reject("prompt cancelled");
								this.getTopParentView().close();
							},
						},
					],
				},
				body: {
					view: "form",
					padding: { top: 0, left: 12, right: 12, bottom: 12 },
					rows: [
						{
							margin: 10,
							cols: [
								{
									view: "text",
									name: "name",
									value: config.value,
									maxWidth: 230,
									validate: safeName,
									css: "webix_fmanager_prompt_input",
								},
								{
									view: "button",
									value: config.button,
									css: "webix_primary",
									width: 100,
									hotkey: "enter",
									click: function() {
										const popup = this.getTopParentView();
										const form = popup.getBody();

										if (form.validate()) {
											const newname = form.getValues().name;
											result.resolve(newname);
											popup.close();
										} else {
											webix.UIManager.setFocus(form);
										}
									},
								},
							],
						},
					],
				},
				on: {
					onShow() {
						const input = this.getBody().elements.name.getInputNode();
						input.focus();
						if (config.selectMask) config.selectMask(input);
						else input.select();
					},
				},
			})
		)
		.show();

	return result;
}
